const extractUrlPath = url => {
  if (!url) return url
  const check = /(http|https):\/\/(www\.|)(gigplanet\.no)/
  const arr = url.match(check)
  if (!arr) return url
  return url.substring((arr[0] || []).length)
}

export default extractUrlPath
